module.exports = __webpack_public_path__ + "static/media/offer.f3b96bfd.jpg";